module.exports = __webpack_public_path__ + "img/hr-electric-furnace-heater.cb617d2c.png";